/**
 * Reviewcijfers van Elvion Group Nederland.
 *
 * Dit is de enige plek waar deze cijfers staan — pas ze hier aan en ze
 * wijzigen overal op de site (homepage-badge + footer).
 *
 * Belangrijk: voeg voor deze reviews GEEN AggregateRating- of
 * Review-structured data (JSON-LD) toe. Google beschouwt reviews over het
 * eigen bedrijf op de eigen site als self-serving en toont daar geen
 * sterren voor; de markup heeft dus geen nut.
 */
/** Directe link waarmee een klant meteen een Google-review kan schrijven. */
export const GOOGLE_REVIEW_SCHRIJVEN_URL =
  "https://search.google.com/local/writereview?placeid=ChIJ7UZbO22rx0cR1HIHI7e3ijU";

export const REVIEW_STATS = {
  /** Peildatum van de cijfers hieronder. */
  bijgewerkt: "oktober 2026",
  totaal: {
    score: 9.8,
    schaal: 10,
    aantal: 35,
  },
  bronnen: [
    {
      naam: "Homedeal",
      score: 9.8,
      schaal: 10,
      aantal: 27,
      url: "https://www.homedeal.nl/pro/Jj8dM/elvion-group-nederland/",
    },
    {
      naam: "Google",
      score: 4.9,
      schaal: 5,
      aantal: 8,
      url: "https://share.google/1vLIugb7inNAlHDd1",
    },
  ],
} as const;

/** Nederlandse decimaalweergave: 9.8 → "9,8". */
export function formaatScore(score: number): string {
  return score.toFixed(1).replace(".", ",");
}

/**
 * Of de grote reviewbadge op de homepage zichtbaar is. De badge blijft altijd
 * gemonteerd (cijfers, links en bronvermelding blijven in de code staan); op
 * false is hij op desktop, tablet én mobiel niet te zien.
 */
export const REVIEW_BADGE_TONEN = false;
